import { useEffect, useRef } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { useXR } from "@react-three/xr";
import { createFloorRecovery } from "./floorRecovery";

export default function XrFloorRecovery() {
  const { gl } = useThree();
  const player = useXR(state => state.player);
  const session = useXR(state => state.session);
  const isPresenting = useXR(state => state.isPresenting);
  const recovery = useRef(null);

  useEffect(() => {
    if (!session || !player || !isPresenting) return;
    const state = { policy: createFloorRecovery(), reference: null };
    state.onReset = () => state.policy.reset();
    recovery.current = state;
    return () => {
      state.reference?.removeEventListener?.("reset", state.onReset);
      recovery.current = null;
      player.position.y = 0;
      player.updateMatrixWorld(true);
    };
  }, [session, player, isPresenting]);

  useFrame((_, __, frame) => {
    const state = recovery.current;
    const reference = gl.xr.getReferenceSpace();
    if (!state || !frame || !reference || session.visibilityState === "hidden") return;
    if (state.reference !== reference) {
      state.reference?.removeEventListener?.("reset", state.onReset);
      state.reference = reference;
      reference.addEventListener?.("reset", state.onReset);
      state.policy.reset();
    }
    const offset = state.policy.sample(frame.getViewerPose(reference));
    if (offset === null) return;
    // Move the tracking rig, including hands and controllers, as one unit.
    // Scenery, car, contact shadow and teleport surface keep their common floor.
    player.position.y = offset;
    player.updateMatrixWorld(true);
    if (offset !== 0) console.warn("Toyota XR: invalid floor origin; using estimated standing height for this session.");
  }, -100);

  return null;
}
